export { default as DefaultPage } from './DefaultPage';
export { default as FiltroDinamico } from './FiltroDinamico';
export { default as HighChart } from './HighChart';
export { default as TopoPagina } from './TopoPagina';



// WEBPACK FOOTER //
// ./src/features/componentes/index.js